"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fixProductOptions = exports.hasInvalidProductOption = exports.checkProjectTranslated = void 0;
const axios_1 = __importDefault(require("axios"));
const Project_1 = require("../models/Project");
const either_1 = require("../types/either");
const sleep_1 = __importDefault(require("./sleep"));
const helpers_1 = require("../api/requests/helpers");
const checkProjectTranslated = (resource, token) => __awaiter(void 0, void 0, void 0, function* () {
  var _a;
  try {
    console.log('checkProjectTranslated INIT');
    if (!resource) {
      return (0, either_1.left)(new Error(`Missing new resource url, got: ${resource}`));
    }
    if (!token) {
      return (0, either_1.left)(new Error(`Missing token, got: ${token}`));
    }
    let initTimeout = 500;
    let response = null;
    const TIMEOUT_MULTIPLIER = 1.2;
    while ((response === null || response === void 0 ? void 0 : response.status) !== 200) {
      try {
        yield (0, sleep_1.default)(initTimeout);
        response = yield axios_1.default.get(resource, (0, helpers_1.axiosConfig)(token));
        initTimeout *= TIMEOUT_MULTIPLIER;
      } catch (error) {
        if ((_a = error === null || error === void 0 ? void 0 : error.message) === null || _a === void 0 ? void 0 : _a.includes('404')) {
          continue;
        } else {
          return (0, either_1.left)(new Error('Error on exponential back off of translated project'));
        }
      }
    }
    if ((0, Project_1.isProject)(response === null || response === void 0 ? void 0 : response.data)) {
      return (0, either_1.right)(response === null || response === void 0 ? void 0 : response.data);
    } else {
      return (0, either_1.left)(new Error('Error from new resource for translating project'));
    }
  } catch (e) {
    console.log('checkProjectTranslated', e);
    return (0, either_1.left)(new Error('Error on exponential back off of translated project'));
  }
});
exports.checkProjectTranslated = checkProjectTranslated;
const isValidProductOption = (value, attributeOptions) => {
  return attributeOptions.find(option => option.value === value);
};
const hasInvalidProductOption = (project, art) => {
  const productOptionKeys = Object.keys(project.product.options);
  const invalidOption = productOptionKeys.find(optionKey => {
    const optionValue = project.product.options[optionKey];
    return !isValidProductOption(optionValue, art.attributes[optionKey].options);
  });
  return !!invalidOption;
};
exports.hasInvalidProductOption = hasInvalidProductOption;
// If a project option value doesn't exist in the template, default to the first value.
const fixProductOptions = (project, art) => {
  let newOptions = {};
  const productOptionKeys = Object.keys(project.product.options);
  productOptionKeys.forEach(optionKey => {
    const optionValue = project.product.options[optionKey];
    if (!isValidProductOption(optionValue, art.attributes[optionKey].options)) {
      newOptions = Object.assign(Object.assign({}, newOptions), {
        [optionKey]: art.attributes[optionKey].options[0].value
      });
    }
  });
  return newOptions;
};
exports.fixProductOptions = fixProductOptions;